__turbopack_context__.v({
  "accordionSlideOverwrite": "styles-module-scss-module__bObY_a__accordionSlideOverwrite",
  "container": "styles-module-scss-module__bObY_a__container",
  "containerWrapper": "styles-module-scss-module__bObY_a__containerWrapper",
  "fadeIn": "styles-module-scss-module__bObY_a__fadeIn",
  "fadeOut": "styles-module-scss-module__bObY_a__fadeOut",
  "header": "styles-module-scss-module__bObY_a__header",
  "scaleIn": "styles-module-scss-module__bObY_a__scaleIn",
  "scaleOut": "styles-module-scss-module__bObY_a__scaleOut",
  "zoomIn": "styles-module-scss-module__bObY_a__zoomIn",
  "zoomOut": "styles-module-scss-module__bObY_a__zoomOut",
});
